export interface ArchProject {
  id: string;
  title: string;
  category: 'residencial' | 'comercial' | 'interiores' | 'paisagismo';
  area: string;
  location: string;
  year: string;
  imageAfter: string;
  imageBefore?: string;
  description: string;
  featured: boolean;
}

export interface ConstructionMilestone {
  id: string;
  phase: string;
  progress: number;
  status: 'Concluído' | 'Em Andamento' | 'Aguardando';
  date: string;
  notes: string;
}

export const arquiteturaProjetos: ArchProject[] = [
  {
    id: 'proj_001',
    title: 'Casa Gabriel — Residência Contemporânea',
    category: 'residencial',
    area: '680 m²',
    location: 'Jardins, São Paulo - SP',
    year: '2025',
    imageAfter: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=800&auto=format&fit=crop',
    imageBefore: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=800&auto=format&fit=crop',
    description: 'Residência minimalista integrada à natureza com balanços de concreto aparente e ripados de madeira cumaru.',
    featured: true
  },
  {
    id: 'proj_002',
    title: 'Apartamento Jardins — Interiores Autorares',
    category: 'interiores',
    area: '320 m²',
    location: 'Itaim Bibi, São Paulo - SP',
    year: '2024',
    imageAfter: 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?q=80&w=800&auto=format&fit=crop',
    imageBefore: 'https://images.unsplash.com/photo-1513694203232-719a280e022f?q=80&w=800&auto=format&fit=crop',
    description: 'Projeto de interiores focado em pedras naturais, mármore travertino navona e peças de iluminação assinadas.',
    featured: true
  },
  {
    id: 'proj_003',
    title: 'Sede Corporativa Faria Lima',
    category: 'comercial',
    area: '1.200 m²',
    location: 'São Paulo - SP',
    year: '2025',
    imageAfter: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=800&auto=format&fit=crop',
    description: 'Escritório corporativo para fundo de investimentos focado em conforto acústico e iluminação circadiana.',
    featured: false
  },
  {
    id: 'proj_004',
    title: 'Refúgio de Verão Quinta da Baroneza',
    category: 'residencial',
    area: '890 m²',
    location: 'Itatiba - SP',
    year: '2024',
    imageAfter: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=800&auto=format&fit=crop',
    description: 'Casa de campo com estrutura em madeira MLC, painéis solares invisíveis e borda infinita em pedra vulcânica.',
    featured: true
  }
];

export const cronogramaObraCliente: ConstructionMilestone[] = [
  {
    id: 'stg_01',
    phase: 'Fase 1: Demolição & Infraestrutura Elétrica/Hidráulica',
    progress: 100,
    status: 'Concluído',
    date: '02 a 20 de Agosto',
    notes: 'Demolições concluídas. Tubulações de cobre instaladas para ar condicionado VRF.'
  },
  {
    id: 'stg_02',
    phase: 'Fase 2: Revestimentos & Porcelanatos Grandes Formatos',
    progress: 85,
    status: 'Em Andamento',
    date: '25 de Agosto a 15 de Setembro',
    notes: 'Assentamento do Mármore Travertino na área social em andamento.'
  },
  {
    id: 'stg_03',
    phase: 'Fase 3: Marcenaria Sob Medida & Montagem',
    progress: 20,
    status: 'Aguardando',
    date: '20 de Setembro a 10 de Outubro',
    notes: 'Módulos de marcenaria em produção no galpão do marcenista.'
  }
];
